export function canvasCoordsForMouseEvent(event: MouseEvent): [number, number] {
  const canvas = event.target as HTMLCanvasElement
  const rect = canvas.getBoundingClientRect()
  return [
    ((event.clientX - rect.left) * canvas.width) / rect.width,
    ((event.clientY - rect.top) * canvas.height) / rect.height,
  ]
}
